import { useEffect, useState } from "react";
import weekFilterDefault from '@/pages/dashboard/filterPageComponents/overview/weekFilterDefault';
import { getWeekRegionCountriesZone } from '@/pages/dashboard/services/overview';
import { formatFilterValues } from '@/pages/dashboard/utils/utils';

/**
 * 按照接口区分为不同model
 * hook名称规范：use+接口名称+Data
 * @param props 父页面所有props
 * @param props: timeZone 时区信息，realtime特有
 * @param props: dispatch dva  dispatch方法
 * @returns 
 * 获取数据的逻辑：dva中有数据则取dva中的数据，否则自己通过接口请求
 */

const useWeekRegionModel = (props: any, formValue: any, dispatch: any, filterLoading: boolean, regionDataType: string) => {
  const { gameCode, } = props;
  const formVal = formValue || weekFilterDefault;
    
  const [componentData, setComponentData] = useState({
    dau: {
      dau_date_list: [],
      dau_list: [],
    },
    revenue: {
      revenue_date_list: [],
      revenue_list: [],
    },
    new: {
      new_date_list: [],
      new_list: [],
    }
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  // // 进入页面的时候
  // useEffect(() => {
  //     if (!formValue) return;
  //     const dvaData = serviceData?.[OVERVIEW_WEEK_REGION];
  //     // if (dvaData) {
  //     //     setComponentData(dvaData?.data)
  //     // } else {
  //         // 当筛选器加载完成后再进行页面请求
  //         if (!filterLoading) {
  //             geRegionDataFunc()
  //         }
  //     // }
  // }, [filterLoading])

  // 点击筛选器的时候
  useEffect(() => {
    if (!formValue) return;
    if (!filterLoading) {
      geRegionDataFunc();
    }
  }, [formVal,regionDataType]);


  const geRegionDataFunc = (isRefresh?: boolean) => {
    const { filterValue } = formVal;
    const { rangeTime, ...filters } = filterValue;
    const rangeTimeArr = rangeTime;
    const [start, end] = rangeTimeArr;
    const params = {
      game_code: gameCode,
      filters: formatFilterValues(filters),
      start_time: start,
      end_time: end,
      by_type: regionDataType,
    };

    setLoading(!isRefresh);
    getWeekRegionCountriesZone(params).then((result: any) => {
      setError('');
      setLoading(false);
      const data = {
        dau: {
          dau_date_list: result?.wau_date_list || [],
          dau_list: result?.wau_list || [],
        },
        revenue: {
          revenue_date_list: result?.revenue_date_list || [],
          revenue_list: result?.revenue_list || [],
        },
        new: {
          new_date_list: result?.new_date_list || [],
          new_list: result?.new_list || [],
        }
      };
      setComponentData(data);
      dispatch({
        type: "overview/getWeekRegionDataFunc",
        payload: {
          data
        }
      });
    }).catch((err: any) => {
      setError(err);
      setLoading(false);
    });
  };
  return {
    // nodata 不在此封装，因为可能是接口的个别项目nodata
    componentData,
    loading,
    error,
  };
};

export default useWeekRegionModel;